import { Component, OnInit } from '@angular/core';
import { ApiKeyService } from './api-key.service';
import { CrazyCallConfigService } from '../lead-generation/shared/services/crazycall-config.service';

@Component({
  selector: 'cc-api',
  templateUrl: './api.component.html',
  styleUrls: ['./api.component.scss']
})
export class ApiComponent implements OnInit {
  public apiKey: string;

  constructor(private apiKeyService: ApiKeyService, private crazyCallConfigService: CrazyCallConfigService) {}

  ngOnInit() {
    this.apiKeyService.get().subscribe(apiKey => {
      this.apiKey = apiKey.apiKey;
    });
  }

  getAccount() {
    return this.crazyCallConfigService.account;
  }

  generate() {
    return this.apiKeyService.generate().subscribe(apiKey => {
      this.apiKey = apiKey.apiKey;
    });
  }

  revoke() {
    return this.apiKeyService.revoke().subscribe(() => {
      this.apiKey = null;
    });
  }
}
